// src/pages/CourtForm.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { TextField, Button, CircularProgress, Box, Grid } from '@mui/material';
import AutohideSnackbar from '../LayoutModule/autohideSnackbar';
import AppGlobalStaticData from '../../appdata/appStaticData';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CourtForm = ({ id, onClose }) => {
  const [court, setCourt] = useState({
    CourtName: '',
    isactive: 1,
    Place: '',
    orderId :0
  });
  const [loading, setLoading] = useState(false);
  const [snackbarProperties,  setSnackbarProperties] = useState({
    duration:0, 
    message:'', 
    serverity:''
  });
    const [snackbarOpen, setSnackbarOpen] = useState(false);
  useEffect(() => {
    if (snackbarProperties.message) {
      setSnackbarOpen(true);
    }
  }, [snackbarProperties.message]);
  
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const globalData = new AppGlobalStaticData();

  useEffect(() => {
    if (id) {
      setLoading(true);
      axios.get(`${API_BASE_URL}/api/v1/court/${id}/get`, {
        headers: { Authorization: `Bearer ${Cookies.get("auth_token")}` },
      })
        .then(response => {
          if (response.data.status === 'Success') {
            setCourt(response.data.data);
            
          } else {
            setSnackbarProperties({
              duration:globalData.Duration, 
              message:globalData.FetchCaseFailed, 
              serverity:globalData.SeverityError
            });
            console.error('Failed to fetch court details');
          }
        })
        .catch(error => {
          setSnackbarProperties({
            duration:globalData.Duration, 
            message:globalData.FetchCaseFailed, 
            serverity:globalData.SeverityError
          });
          console.error('Error fetching court details:', error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCourt({
      ...court,
      [name]: name === "orderId" ? parseInt(value, 10) || 0 : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const token = Cookies.get("auth_token");
    const headers = { Authorization: `Bearer ${token}` };
    const submitRequest = id
      ? axios.put(`${API_BASE_URL}/api/v1/court/${id}/update`, court, { headers })
      : axios.post(`${API_BASE_URL}/api/v1/court/create`, court, { headers });

    submitRequest
      .then(response => {
        if (response.data.status === 'Success') {
          onClose();
          setSnackbarProperties({
            duration:globalData.Duration, 
            message:id  ? globalData.EditCourtSuccess : globalData.AddCourtSuccess, 
            serverity:globalData.SeveritySuccess
          });
        } else {
          setSnackbarProperties({
            duration:globalData.Duration, 
            message:id  ? globalData.EditCourtFailed : globalData.AddCourtFailed,
            serverity:globalData.SeverityError
          });
          console.error(`Failed to ${id ? 'update' : 'create'} court`);
        }
      })
      .catch(error => {
        setSnackbarProperties({
          duration:globalData.Duration, 
          message:id  ? globalData.EditCourtFailed : globalData.AddCourtFailed,
          serverity:globalData.SeverityError
        });
        console.error(`Error ${id ? 'updating' : 'creating'} court:`, error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label="Court Name"
            name="CourtName"
            value={court.CourtName}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Place"
            name="Place"
            value={court.Place}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Order"
            name="orderId"
            value={court.orderId}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Box mt={2}>
            <Button variant="contained" color="primary" type="submit" fullWidth>
              {id ? 'Update' : 'Create'}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <AutohideSnackbar open={snackbarOpen}
        duration={snackbarProperties.duration}
        message={snackbarProperties.message}
        severity={snackbarProperties.serverity}
        handleClose={handleSnackbarClose} ></AutohideSnackbar>
    </form>
  );
};

export default CourtForm;
